import { isxxx } from './isxxx'

const { isWx, isIos } = isxxx

export default {
  data () {
    return {
      downloadList: {
        'tz1': 'https://hoplink.ksosoft.com/mlyc',
        'yyb11': 'https://hoplink.ksosoft.com/4pvj',
        'yyb10': 'https://hoplink.ksosoft.com/yaqj',
        'yyb9': 'https://hoplink.ksosoft.com/gs1g',
        'yyb8': 'https://hoplink.ksosoft.com/oxi0',
        'yyb7': 'https://hoplink.ksosoft.com/vhfp',
        'yyb5': 'https://hoplink.ksosoft.com/q4dx',
        'yyb4': 'https://hoplink.ksosoft.com/zqba',
        'yyb3': 'https://hoplink.ksosoft.com/fnb5',
        'yyb2': 'https://hoplink.ksosoft.com/nrgi',
        'yyb1': 'https://hoplink.ksosoft.com/qocb'
      }
    }
  },
  methods: {
    download (type) {
      if (isIos) {
        return (window.location.href = 'https://itunes.apple.com/app/apple-store/id1439039386?pt=38515&ct=wpsdownload&mt=8')
      }
      if (isWx) {
        window.location.href = `https://course-m.auoktalk.com/download-app?type=${type}&from=${this.$route.query.from}`
        return
      }
      if (this.downloadList[type]) {
        return (window.location.href = this.downloadList[type])
      }
      window.location.href = 'https://staticedu.wps.cn/app/%E6%8E%A2%E7%9F%A5.apk'
    }
  }
}
